<template>
  <div>
    <isrs-i18n-dialog v-bind="{languages, getText, getDefault, onSave, texts}"/>
  </div>
</template>

<script>
  import objectPath from 'object-path';
  import {mapGetters, mapState, mapActions} from 'vuex'

  import IsrsI18nDialog from '../components/IsrsI18nDialog.vue'

  export default {
    props: {
      texts: {
        type: Object,
        required: true
      },
      multiline: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    components: {
      IsrsI18nDialog
    },

    data() {
      return {
        languages: {
          en: 'English',
          de: 'German',
          da: 'Danish',
          pl: 'Polish',
          nl: 'Dutch',
          nl_be: 'Dutch (BE)',
          fr: 'French',
          fr_be: 'French (BE)',
          hu: 'Magyar',
          es: 'Spanish',
          cs: 'Czech',
          sl: 'Slovenian',
          sk: 'Slovak',
          fi: 'Finnish',
          pt: 'Portuguese',
          it: 'Italian',
          hr: 'Croatian',
          sv: 'Swedish',
          et: 'Estonian',
          lt: 'Lithuanian',
          lv: 'Latvian',
        }
      }
    },
    computed: {
      ...mapState('texts', [
        'i18next'
      ])
    },
    methods: {
      getText(lang) {
        if(
          this.texts[lang] &&
          this.texts[lang][this.$route.params.level1] &&
          this.texts[lang][this.$route.params.level1][this.$route.params.level2]
        ) {
          return this.texts[lang][this.$route.params.level1][this.$route.params.level2]
        }
        return this.getDefault(lang)
      },

      getDefault(lang) {
        if(
          this.i18next[lang] &&
          this.i18next[lang]['translation'] &&
          this.i18next[lang]['translation'][this.$route.params.level1] &&
          this.i18next[lang]['translation'][this.$route.params.level1][this.$route.params.level2]
        ) {
          return this.i18next[lang]['translation'][this.$route.params.level1][this.$route.params.level2]
        }
        return ""
      },

      onSave(data) {
        let texts = this.texts;

        Object.keys(this.languages)
          .map(key => [
            key,
            data[key],
            this.getText(key)
          ]).forEach( ([key, newVal, oldVal]) => {
            if(newVal) {
              objectPath.set(this.texts, `${key}.${this.$route.params.level1}.${this.$route.params.level2}`, newVal);
            }
          })

        this.$emit('save', this.texts)
      },

      save() {
        let texts = this.texts;

        Object.keys(this.languages)
          .map(code => [
            code,
            this.$refs[code][0].value !== this.$refs[code][0].lazyValue, // <- value has changed
            this.$refs[code][0].lazyValue
          ])
          .filter(arr => {
            return arr[1]
          }).forEach( data => {
            objectPath.set(texts, `${data[0]}.${this.$route.params.level1}.${this.$route.params.level2}`, data[2]);
          })

        this.texts = texts;
        this.$emit('save', this.texts)
      }
    },


  }
</script>



// WEBPACK FOOTER //
// EditTextsForm.vue?4379821a